import { action, observable, runInAction } from 'mobx';

// TODO move to a better place, since this doesn't apply to just buttons anymore.
export class BusyStore {
  @observable.ref
  value: boolean;

  constructor() {
    this.value = false;
  }

  @action.bound
  async perform<T>(action_: () => Promise<T>): Promise<T> {
    this.value = true;
    try {
      return await action_();
    } finally {
      runInAction(() => {
        this.value = false;
      });
    }
  }
}